import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    isAppLoading: false,
  },
  reducers: {
    pushIsAppLoading: (state, action) => {
      state.isAppLoading = action.payload;
    },
    popIsAppLoading: (state) => {
      state.isAppLoading = false;
    }
  },
});

export const { pushIsAppLoading, popIsAppLoading } = appSlice.actions;

export const selectIsAppLoading = (state) => state.app.isAppLoading;

export default appSlice.reducer;
